import Pages from './pages/Pages';
import HeaderContainer from '../header/HeaderContainer';
import {RolesValidator} from "../../validations/RolesValidator";
import {ROLE} from "../../utils/ROLE";
import {positions, Provider} from "react-alert";
import AlertTemplate from "react-alert-template-basic";


const ContentContainer = () => {
    const options = {
        timeout: 5000,
        position: positions.BOTTOM_RIGHT,
    };

    return (
        <Provider template={AlertTemplate} {...options}>
            {RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST, ROLE.CULINARY, ROLE.MANAGER]) ? (
                <HeaderContainer/>
            ) : (
                <></>
            )}
            <Pages/>
        </Provider>
    );
};
export default ContentContainer;
